import Player from '@vimeo/player';
import { ViewedVideos } from './ViewedVideos';

export class TestimonialStoriesPopup extends ViewedVideos {
    constructor({userId}) {
        super();
        this.userId = userId;
        this.apiUrl = window.testimonialData.samePersonApiRoute;
        this.swalContent = document.createElement('div');
        this.swalContent.classList.add('testimonial-stories-popup');
        this.currentStory = 0;
        this.mutationObserver = new MutationObserver(this.mutationFunction);
        const { closeButton, arrow } = window.testimonialsPageIcons;
        this.closeButton = closeButton;
        this.arrow = arrow;
    };

    mutationFunction(mutationsList) {
        mutationsList.forEach(mutation => {
            if (mutation.attributeName === 'class') {
                if (mutation.oldValue.includes('--show-modal')) {
                    $('.swal-carousell').slick('unslick');
                    $(mutation.target).remove();
                }
            }
        });
    };

    openPopup() {
        // Getting ids of next and previous user
        const ind = $('.user-story-container').index($('.slick-track').find(`[data-user-id="${this.userId}"]`))
        const isNew = $('.slick-track').find(`[data-user-id="${this.userId}"]`).hasClass('new');
        const lengthTotal = $('.slick-track .user-story-container').length;
        const numberNew = $('.slick-track .user-story-container.new').length;
        let prev = ind-1;
        let next = ind+1;

        if (isNew) {
            if (prev < 0) {
                prev = numberNew-1;
            }
            if (next >= numberNew) {
                next = 0;
            }
        } else {
            if (prev < numberNew) {
                prev = lengthTotal-1;
            }
            if (next >= lengthTotal) {
                next = numberNew;
            }
        }

        this.nextUserId = $($('.user-story-container').get(next)).data('user-id');
        this.previousUserId = $($('.user-story-container').get(prev)).data('user-id');

        this.preparePopup();
    };

    createPopup() {
        swal({
            className: 'swal-testimonial',
            content: this.swalContent,
            buttons: false
        });

        this.checkWidth()

        $('.swal-carousell').slick({
            infinite: false,
            rows: 0,
            slide: '.story-video',
            prevArrow: $('#stories-prev'),
            nextArrow: $('#stories-next')
        }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            this.handleBeforeChange({currentSlide, nextSlide, slides: slick.$slides})
        }).on('afterChange', (event, slick) => {
            this.checkWidth()
        }).on('swipe', (event, slick, direction) => {
            this.checkWidth()
            if (direction === 'left') {
                let testimonialId;

                if (slick.animating) {
                    testimonialId = $($(slick.$slides[slick.currentSlide-1]).find('video')).data('testimonial-id');
                    this.addToViewed(testimonialId);
                } else {
                    testimonialId = $($(slick.$slides[slick.currentSlide]).find('video')).data('testimonial-id');
                    this.addToViewed(testimonialId);
                    this.goToNextUser();
                }
            } else {
                if (!slick.animating) {
                    this.goToNextUser(false);
                }
            }
        });

        $('.story-video video').each((index, element) => {
            if (this.currentStory === index) {
                element.play();
            }

            element.addEventListener('timeupdate', (event) => {
                const width = Math.ceil((event.target.currentTime / event.target.duration) * 100);
                if ($('.story-video video').length === index+1 && width >= 100) {
                    const testimonialId = $(event.currentTarget).data('testimonial-id');
                    this.addToViewed(testimonialId);
                    this.timeIndicatorsViewed();
                    this.goToNextUser();
                } else {
                    this.updateTimeIndicators(`${width}%`);
                }
            });

            element.addEventListener('ended', (event) => {
                $('.swal-carousell').slick('slickGoTo', this.currentStory+1);
                const testimonialId = $(event.currentTarget).data('testimonial-id');
                this.addToViewed(testimonialId);
            });
        });

        $('.story-video iframe').each((index, element) => {
            const player = new Player(element);
            if (this.currentStory === index) {
                player.setVolume(1).catch(e => console.log(e));
                player.play().catch(e => console.log(e));
            } else {
                player.pause().catch(e => console.log(e));
                player.setCurrentTime(0).catch(e => console.log(e));
            }

            player.on('timeupdate', (event) => {
                const width = event.percent * 100;
                if ($('.story-video iframe').length === index+1 && width >= 100) {
                    this.timeIndicatorsViewed();
                } else {
                    this.updateTimeIndicators(`${width}%`);
                }
            });

            player.on('ended', () => {
                const testimonialId = $(element).data('testimonial-id');
                this.addToViewed(testimonialId);
                $('.swal-carousell').slick('slickGoTo', this.currentStory + 1);
                $(element).find('.thumbnail').removeClass('hidden');
                this.goToNextUser();
            });
        });

        this.addEventListeners();
    };

    handleBeforeChange({currentSlide, nextSlide, slides}) {
        if (currentSlide !== nextSlide) {
            if ($('.story-video video').exists()) {
                $('.story-video video').eq(currentSlide)[0].pause();
                $('.story-video video').eq(currentSlide)[0].currentTime = 0;
                $('.story-video video').eq(nextSlide)[0].play();
            } else {
                const player = new Player($('.story-video iframe').eq(currentSlide)[0]);
                player.pause().catch(e => console.log(e));
                player.setCurrentTime(0).catch(e => console.log(e));

                const toPlay = new Player($('.story-video iframe').eq(nextSlide)[0]);
                toPlay.play().catch(e => console.log(e));
                toPlay.setVolume(1).catch(e => console.log(e));
            }
        }

        if (nextSlide > currentSlide) {
            this.currentStory += 1;
        } else if (nextSlide < currentSlide) {
            this.currentStory -= 1;
        }

        if (this.currentSlide === slides.length) {
            this.currentStory = 0;
        }

        if (this.currentSlide < 0) {
            this.currentStory = slides.length - 1;
        }

        if (currentSlide !== nextSlide) {
            this.updateView();
        }
    };

    updateView() {
        const tags = $('.testimonial-stories-popup').find('.tags');
        const question = $('.testimonial-stories-popup').find('.testimonial-question');

        $(tags).empty().append(this.createTags(this.currentUserTestimonials[this.currentStory].categories));
        $(question).empty().append(this.currentUserTestimonials[this.currentStory].question.question);

        this.updateTimeIndicators();
    };

    updateTimeIndicators(width) {
        const timeIndicators = $('.testimonial-stories-popup').find('.time-indicators .indicator');

        $(timeIndicators).each((index, element) => {
            if (index < this.currentStory) {
                $(element).removeClass('current').addClass('viewed');
            } else if (index == this.currentStory) {
                $(element).removeClass('viewed').addClass('current');
                $(element).find('.fill').css('width', width);
            } else {
                $(element).removeClass('viewed').removeClass('current');
            }
        });
    };

    timeIndicatorsViewed() {
        const timeIndicators = $('.testimonial-stories-popup').find('.time-indicators .indicator');

        $(timeIndicators).each((index, element) => {
            $(element).removeClass('current').addClass('viewed');
        });
    };

    async fetchData() {
        const axiosOptions = {
            params: {
                currentId: this.userId,
                previousId: this.previousUserId,
                nextId: this.nextUserId
            }
        };

        try {
            const response = await axios.get(this.apiUrl, axiosOptions);

            return await response.data;
        } catch (error) {
            console.log(error);
        }
    };

    checkWidth() {
        if (parseInt(this.currentUserTestimonials[this.currentStory].width) > parseInt(this.currentUserTestimonials[this.currentStory].height)) {
            $('.swal-testimonial').addClass('wide-video')
        } else {
            $('.swal-testimonial').removeClass('wide-video')
        }
    }

    preparePopup() {
        this.fetchData().then(data => {
            this.currentUserTestimonials = data?.data?.testimonials ?? [];
            const viewedVideos = JSON.parse(localStorage.getItem("Videos"));

            if (viewedVideos && viewedVideos[this.userId]) {
                if (!viewedVideos[this.userId].allViewed) {
                    this.currentUserTestimonials = this.currentUserTestimonials.filter(testimonial =>
                        testimonial.author.id === viewedVideos[this.userId].userId && !viewedVideos[this.userId].videosViewed.includes(testimonial.id));
                }
            }

            const next = data.data.next;
            const previous = data.data.previous;
            const content = `
                <div class="testimonial">
                    <div class="testimonial-top">
                        <div class="question-wrapper">
                            <div class="time-indicators">
                                ${this.currentUserTestimonials.map((current, index) => {
                                    return `
                                            <div class="indicator ${index === this.currentStory ? "current" : ""}"><div class="fill"></div></div>
                                    `
                                }).join('')}
                            </div>
                            <div class="testimonial-question">
                                ${this.currentUserTestimonials[this.currentStory].question.question}
                            </div>
                        </div>
                        <button class="swal-close" onClick="swal.close()">
                            ${this.closeButton}
                        </button>
                    </div>
                    <div class="swal-carousell">
                        <div class="same-questions story-view">
                            ${this.previousUserId !== this.currentUserTestimonials[0].author.id ?`
                                <div class="same-question left">
                                    <div class="user" data-user-id=${previous.id}>
                                        <div class="image">
                                            <img src="${previous.avatar}" />
                                        </div>
                                        <p class="name">${previous.name}</p>
                                    </div>
                                </div>
                            ` : ""}
                            ${this.nextUserId !== this.currentUserTestimonials[0].author.id ? `
                                <div class="same-question right">
                                    <div class="user" data-user-id=${next.id}>
                                        <div class="image">
                                            <img src="${next.avatar}" />
                                        </div>
                                        <p class="name">${next.name}</p>
                                    </div>
                                </div>
                            ` : ""}
                        </div>
                        <div class="swal-carousell-buttons">
                            <button class="slick-prev slick-arrow swal-carousel-button" id="stories-prev">
                                ${this.arrow}
                            </button>
                            <button class="slick-next slick-arrow swal-carousel-button" id="stories-next">
                                ${this.arrow}
                            </button>
                        </div>
                        ${this.currentUserTestimonials.map((current, index) => {
                            return `
                            <div class="story-video">
                                <div class="video-container">
                                ${current.type ?
                                    `<iframe src="${current.video}" frameborder="0" allow="autoplay" allowfullscreen="" data-testimonial-id="${current.id}"></iframe>
                                    <div class="thumbnail">
                                        <img class="loading-icon" src="/static/images/loading.svg" />
                                        <img class="placeholder" src="${current.vimeoThumbnail}" />
                                    </div>
                                    `
                                    :
                                    `<video ${index === 0 ? "autoplay" : ""} data-testimonial-id=${current.id}>
                                        <source src="${current.video}" >
                                    </video>`
                                }
                                </div>
                            </div>
                            `
                        }).join('')}
                    </div>
                    <div class="person-info">
                        <img class="person-image" src="${this.currentUserTestimonials[0].author.avatar}" />
                        <div class="name">${this.currentUserTestimonials[0].author.name}</div>
                        <div class="position">${this.currentUserTestimonials[0].author.position}</div>
                    </div>
                    <div class="tags">
                        ${this.createTags(this.currentUserTestimonials[this.currentStory].categories)}
                    </div>
                </div>
            `

            $(this.swalContent).empty().append(content);
            this.createPopup();
            this.mutationObserver.observe($('.swal-overlay')[0], { attributes: true, attributeOldValue: true });
        }).catch(error => {
            console.log(error);
        });
    };

    createTags(tagList) {
        return `
            ${tagList.map((tag) => {
                return `<a class="tag" data-id="${tag.id}">${tag.category}</a>`
            })}
        `
    };

    addEventListeners() {
        $('.same-questions').on('click', '.same-question .user', (event) => {
            this.userId = $(event.currentTarget).data('user-id');
            swal.close();
            this.currentStory = 0;
            this.openPopup();
        });

        $('.swal-carousel-button').on('click', (event) => {
            const slick = $('.swal-carousell').slick('getSlick');

            if (event.currentTarget.id === "stories-next") {
                let testimonialId;

                if (slick.currentSlide === slick.slideCount-1 && !slick.animating) {
                    testimonialId = $($(slick.$slides[slick.currentSlide]).find('video')).data('testimonial-id');
                    if (!testimonialId) {
                        testimonialId = $($(slick.$slides[slick.currentSlide]).find('iframe')).data('testimonial-id');
                    }

                    this.addToViewed(testimonialId);
                    this.goToNextUser();
                } else {
                    testimonialId = $($(slick.$slides[slick.currentSlide-1]).find('video')).data('testimonial-id');
                    if (!testimonialId) {
                        testimonialId = $($(slick.$slides[slick.currentSlide-1]).find('iframe')).data('testimonial-id');
                    }

                    this.addToViewed(testimonialId);
                }
            } else {
                if (slick.currentSlide === 0 && !slick.animating) {
                    this.goToNextUser(false);
                }
            }
        });

        $('.swal-carousell .story-video').each((index, element) => {
            let bufferStarted = false;
            const vimeoVideo = $(element).find('.video-container iframe')[0];

            if (vimeoVideo) {
                const player = new Player(vimeoVideo);

                player.on('bufferstart', () => {
                    bufferStarted = true;
                });

                player.on('bufferend', () => {
                    bufferStarted = false;
                    $(element).find('.thumbnail').addClass('hidden');
                });

                player.on('play', () => {
                    if (!bufferStarted) {
                        $(element).find('.thumbnail').addClass('hidden');
                    }
                });
            }
        });

        $('.testimonial-stories-popup .testimonial').on('click', '.tags .tag', (event) => {
            const categoryId = $(event.currentTarget).data('id').toString();
            swal.close();
            window.testimonialFilter.handleTagClick(categoryId);
        });
    };

    goToNextUser(next = true) {
        if (next) {
            this.userId = $('.same-question.right .user').data('user-id');

            if (this.userId) {
                $('.swal-content .testimonial-stories-popup').empty();
                swal.close();
                this.currentStory = 0;
                this.openPopup();
            }
        } else {
            this.userId = $('.same-question.left .user').data('user-id');

            if (this.userId) {
                $('.swal-content .testimonial-stories-popup').empty();
                swal.close();
                this.currentStory = 0;
                this.openPopup();
            }
        }

    };

    addToViewed(testimonialId) {
        let viewedVideos = JSON.parse(localStorage.getItem('Videos'));

        if (viewedVideos && viewedVideos[this.userId]) {
            // If user exists in local storage check a bunch of things
            if (!viewedVideos[this.userId].videosViewed.includes(testimonialId)) {
                viewedVideos[this.userId].videosViewed.push(testimonialId);
                viewedVideos[this.userId].videosViewed.sort();
                if (this.areEqual(viewedVideos[this.userId].videosViewed, viewedVideos[this.userId].allVideos)) {
                    viewedVideos[this.userId].allViewed = true;
                }
            }
        } else {
            // If user doesn't exist in local storage we will add it
            let allVideos = this.currentUserTestimonials.reduce((acc, current) =>
                acc = [...acc, current.id]
            , []);
            allVideos.sort();
            viewedVideos = {
                ...viewedVideos,
                [this.userId]: {
                    userId: this.userId,
                    allViewed: testimonialId ? (this.areEqual(allVideos, [testimonialId]) ? true : false) : false,
                    allVideos: allVideos,
                    videosViewed: testimonialId ? [testimonialId] : []
                }
            };
        }

        localStorage.setItem('Videos', JSON.stringify(viewedVideos));
        this.checkViewed();
    };

};